import React from "react";
import { Link } from "react-router-dom";
import './footer.css';

const Footer = () => {

    return (

        <div className="footer">

            <div className="footer-content">
                <span><Link to="/impressum" className="footer-link">Impressum</Link></span>
                <span><Link to="/datenschutz" className="footer-link">Datenschutzerklärung</Link></span>
            </div>

        </div>
    )
};


export default Footer